module.exports = __webpack_public_path__ + "static/media/Denodo_Alexey Sidorov_Photo (1).7f3be0e2.jpg";